import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { getPeopleAndAccessAnalytics } from 'src/services/analytics.service';
import StackedHorizontalBarChart from 'src/sections/@dashboard/app/StackedHorizontalBarChart';


class PeopleAndAccessAnalytics extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            is_percentage: this.props.is_percentage || false,
            by: this.props.by || 'count',
            access_overview: {
                by_count: {},
                by_size: {}
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.by !== this.props.by || prevProps.is_percentage !== this.props.is_percentage) {
            this.setState({
                by: this.props.by,
                is_percentage: this.props.is_percentage
            });
        }
    }

    async componentDidMount() {

        let query = null;
        if (this?.props?.user_id) {
            query = {
                user_id: this.props.user_id
            };
        }
        let people_and_access_analytics = await getPeopleAndAccessAnalytics(query);
        
        if (people_and_access_analytics.error) {
            console.error(people_and_access_analytics.error);
            return;
        }
        people_and_access_analytics = people_and_access_analytics.people_and_access_analytics;

        let people_and_access_analytics_by_count = people_and_access_analytics.by_count || {};
        let people_and_access_analytics_by_size = people_and_access_analytics.by_size || {};
        

        // Access Overview Data
        let access_overview_data_by_count = [];
        access_overview_data_by_count.push({
            name: 'Internally Shared',
            label: 'Internally Shared',
            data: [people_and_access_analytics_by_count.internally_shared_files_count || 0],
            color: '#f6c23e',
            stack: 'Count'
        });
        access_overview_data_by_count.push({
            name: 'Externally Shared',
            label: 'Externally Shared',
            data: [people_and_access_analytics_by_count.externally_shared_files_count || 0],
            color: '#e36d26',
            stack: 'Count'
        });
        access_overview_data_by_count.push({
            name: 'Not Shared',
            label: 'Not Shared',
            data: [(people_and_access_analytics_by_count.total_files_count - (people_and_access_analytics_by_count.internally_shared_files_count || 0) - (people_and_access_analytics_by_count.externally_shared_files_count || 0) || 0)],
            color: '#94cd81',
            stack: 'Count'
        });
        // access overview data by count percentage
        let total_count = access_overview_data_by_count.reduce((acc, curr) => acc + curr.data[0], 0);
        let access_overview_data_by_count_percentage = access_overview_data_by_count.map(item => ({
            ...item,
            data: total_count > 0 ? [(item.data[0] / total_count) * 100] : [0]
        }));

        let access_overview_data_by_size = [];
        access_overview_data_by_size.push({
            name: 'Internally Shared',
            label: 'Internally Shared',
            data: [people_and_access_analytics_by_size.internally_shared_files_size || 0],
            color: '#f6c23e',
            stack: 'Size'
        });
        access_overview_data_by_size.push({
            name: 'Externally Shared',
            label: 'Externally Shared',
            data: [people_and_access_analytics_by_size.externally_shared_files_size || 0],
            color: '#e36d26',
            stack: 'Size'
        });
        access_overview_data_by_size.push({
            name: 'Not Shared',
            label: 'Not Shared',
            data: [(people_and_access_analytics_by_size.total_files_size - (people_and_access_analytics_by_size.internally_shared_files_size || 0) - (people_and_access_analytics_by_size.externally_shared_files_size || 0) || 0)],
            color: '#94cd81',
            stack: 'Size'
        });
        // access overview data by size percentage
        let total_size = access_overview_data_by_size.reduce((acc, curr) => acc + curr.data[0], 0);
        let access_overview_data_by_size_percentage = access_overview_data_by_size.map(item => ({
            ...item,
            data: total_size > 0 ? [(item.data[0] / total_size) * 100] : [0]
        }));

        this.setState({
            access_overview_data_by_count: access_overview_data_by_count,
            access_overview_data_by_count_percentage: access_overview_data_by_count_percentage,
            access_overview_data_by_size: access_overview_data_by_size,
            access_overview_data_by_size_percentage: access_overview_data_by_size_percentage
        });
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h5" fontWeight={400} color={'gray'}>
                        People and access
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <StackedHorizontalBarChart
                        series={this.state.is_percentage ? 
                            (this.state.by === 'count' ? this.state.access_overview_data_by_count_percentage : this.state.access_overview_data_by_size_percentage ) :
                            (this.state.by === 'count' ? this.state.access_overview_data_by_count : this.state.access_overview_data_by_size)
                        }
                        labels={[this.state.by === 'count' ? 'Count' : 'Size']}
                        value_type={this.state.is_percentage ? 'percentage' : this.state.by}
                    />
                </Grid>
            </Grid>
        );
    }
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();

    return <PeopleAndAccessAnalytics {...props} navigate={navigate} params={params} />;
}
